
import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Api } from '../../services/api';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { BillableService } from '../../services/billable-servise';
import { json } from 'react-router-dom';
import axios from 'axios';
import { Button } from 'primereact/button';
import { useCallback } from 'react';

const Budget = () => {


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [projectTypeID, setProjectTypeID] = useState();
  const [type, setType] = useState('Add');
  const [excelFile, setExcelFile] = useState(null);
  const [isFormSubmitLoadder, setIsFormSubmitLoadder] = useState(false);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [isRelplace, setIsRelplace] = useState('N');
  const [isRelplaceMessage, setIsRelplaceMessage] = useState("null");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedExcelFile, setSelectedExcelFile] = useState();

  const [isReplaceConfirmationModalOpen, setIsReplaceConfirmationModalOpen] = useState(false);

  const [typeError, setTypeError] = useState(null);
  const [yearsList, setYearsList] = useState(BillableService.getMonthAndYearList().years);
  const [monthsList, setMonthsList] = useState(BillableService.getMonthAndYearList().months);
  const [columnList, setColumnList] = useState([]);
  const [rowList, setRowList] = useState([]);
  const [budgetList, setBudgetList] = useState([]);

  const [setTitleAFrozen, setSetTitleAFrozen] = useState(false);
  const [setTitleBFrozen, setSetTitleBFrozen] = useState(false);
  const [setTitleCFrozen, setSetTitleCFrozen] = useState(false);
  const [setTitleDFrozen, setSetTitleDFrozen] = useState(false);
  const [setTitleEFrozen, setSetTitleEFrozen] = useState(false);
  const [setTitleFFrozen, setSetTitleFFrozen] = useState(false);
  const [setTitleGFrozen, setSetTitleGFrozen] = useState(false);
  const [setTitleHFrozen, setSetTitleHFrozen] = useState(false);




  const toast = useRef(null);


  //   const openModal = () => {
  //     setProjectTypeID('');

  //     setType('Add');

  //     setIsModalOpen(true);
  // };

  const openModal = useCallback(() => {
    setProjectTypeID('');

    setType('Add');
    setIsModalOpen(true);
  }, [setIsModalOpen]);



  // const closeModal = () => {
  //     setIsModalOpen(false);

  // };

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);

  useEffect(() => {

    getBudgetData();






  }, []);

  const getBudgetData = () => {
    axios.get(Api.API_BASE_URL + 'budget/budget-get-all')
      .then((response) => {


        setBudgetList(response.data.result)
        setColumnList(response.data.ColumnName)



        var arr2 = [];
        response.data.ColumnName.forEach(element => {

          var ar = [{
            field: element,
            name: response.data.RowName[0],

          },
          {
            field: element,
            name: response.data.RowName[1],

          }, {
            field: element,
            name: response.data.RowName[2],

          }]

          var mergedArray = arr2.concat(ar);
          arr2 = mergedArray;

        });


        setRowList(arr2);



        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
        setIsLoading(false);
      });
  }
  const budget = (rowData) => {
    if (rowData.budget == 0) {
      return '';
    }
    return `${formatCurrency(rowData.budget)}`;
  };

  const formatCurrency = (value) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };


  const rowClass = (data) => {
    return {
      'bg-yellow-300': data.titleB !== '',
      'bg-yellow-100': data.titleD !== '',
      'bg-yellow-200': data.titleC !== '',
      'bg-yellow-400': data.titleA !== '',
      'bg-green-300': data.titleE !== '',
      'bg-green-200': data.titleF !== '',
      'bg-green-100': data.titleG !== '',

      // 'bg-yellow-300': data.titleB === 'Ordinary Income/Expense' || data.titleB === 'Net Ordinary Income'|| data.titleB === 'Other Income/Expense'|| data.titleB === 'Net Other Income',
      // 'bg-yellow-100': data.titleD === 'Income'|| data.titleD === 'Total Income'|| data.titleD === 'Cost of Goods Sold'|| data.titleD === 'Total COGS'|| data.titleD === 'Expense'|| data.titleD === 'Total Expense',
      // 'bg-yellow-200': data.titleC === 'Gross Profit',
      // 'bg-yellow-400': data.titleA === 'Net Income',
      // 'bg-green-300': data.titleE !== '',
      // 'bg-green-200': data.titleF !== '',
      // 'bg-green-100': data.titleG !== '',


    };
  };


  // -------------------------------------
  const handleFile = (e) => {
    let fileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
    let selectedFile = e.target.files[0];

    setSelectedExcelFile(selectedFile)
    if (selectedFile) {
      if (selectedFile && fileTypes.includes(selectedFile.type)) {
        setTypeError(null);
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFile(e.target.result);
        }
      }
      else {
        setTypeError('Please select only excel file types');
        setExcelFile(null);
      }
    }
    else {
      console.log('Please select your file');
    }
  }


  const handleFileSubmit = async (e) => {
    e.preventDefault();
    // start Loader

    if (excelFile !== null) {
      setIsFormSubmitLoadder(true)

      const formData = new FormData();
      console.log("isRelplaceMessage:", selectedYear.year);
      var year = selectedYear.year;
      var month = selectedMonth.month;
      formData.append("year", year);
      formData.append("month", month);
      formData.append("isRelplace", isRelplace);
      formData.append("excel_file", selectedExcelFile);



      // fetch(API_BASE_URL + 'excel-upload-actual-pm', {
      fetch(Api.API_BASE_URL + 'budget/budget-save', {
        method: "POST",
        headers: {
          //  "Content-Type":"multipart/form-data",
        },
        body: formData,
        // body: JSON.stringify({'excel_file':selectedExcelFile}),
      })
        .then((response) => response.json())
        .then((Josn) => {
          setIsFormSubmitLoadder(false)
          if (Josn.error !== '') {

            // End Loader
            if (Josn.isRelplace === "Y") {
              // closeModal();
              setIsModalOpen(false)
              setIsRelplaceMessage(Josn.error.toString());

              setIsReplaceConfirmationModalOpen(true)

              setIsRelplace(Josn.isRelplace)
            } else {
              toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
            }

          } else {

            console.log(Josn.result);
            // End Loader
            setIsReplaceConfirmationModalOpen(false)

            setSelectedYear(null);
            setSelectedMonth(null);

            setExcelFile(null);
            setIsRelplace("N");
            closeModal();
            toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
            // toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });




            // getProjectType();
          }





        })
        .catch((error) => {
          console.error("Error:", error);
        });// You can adjust this as needed



    }
  };




  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header='' rowSpan={2} frozen colSpan={5} style={{ minWidth: '100px', textAlign: "center" }} />
        {/* <Column  header='' rowSpan={2} colSpan={8} style={{ minWidth: '100px', textAlign: "center"}} /> */}
        {/* <Column  header={()=>lockTemplate(setTitleAFrozen)} rowSpan={2} style={{ minWidth: '100px', textAlign: "center"}} />
        <Column header={()=>lockTemplate(setTitleAFrozen)} rowSpan={2} style={{ minWidth: '100px', textAlign: "center" }} />
        <Column header={()=>lockTemplate(setTitleAFrozen)} rowSpan={2} style={{ minWidth: '100px', textAlign: "center" }} />
        <Column header={()=>lockTemplate(setTitleAFrozen)} rowSpan={2} style={{ minWidth: '100px', textAlign: "center" }} />
        <Column header={()=>lockTemplate(setTitleAFrozen)}  rowSpan={2} style={{ minWidth: '100px', textAlign: "center"}} />
        <Column header={()=>lockTemplate(setTitleAFrozen)} rowSpan={2} style={{ minWidth: '100px', textAlign: "center" }} />
        <Column header={()=>lockTemplate(setTitleAFrozen)} rowSpan={2} style={{ minWidth: '100px', textAlign: "center" }} />
        <Column header={()=>lockTemplate(setTitleAFrozen)} rowSpan={2}  style={{ minWidth: '100px', textAlign: "center" }} /> */}
        {columnList.map((column, columnIndex) => (
          <Column key={columnIndex} header={column} colSpan={3} style={{ minWidth: '120px', textAlign: 'center' }} />

        ))}
      </Row>
      <Row>
        {rowList.map((row, rowIndex) => (
          <Column header={row.name} style={{ minWidth: '120px', textAlign: 'center' }} />
        ))}
      </Row>
    </ColumnGroup>
  );
  const lastYearSaleBodyTemplate = (col, rowData) => {
    // return rowData[col.field][col.name];
    if (rowData[col.field][col.name] == 0 || rowData[col.field][col.name] == null) {
      return '';
    }
    if (rowData[col.field][col.name] < 0) {
      return <span style={{ color: "red" }}>
        {formatCurrency(rowData[col.field][col.name])}
      </span>
    }
    return `${formatCurrency(rowData[col.field][col.name])}`;
    // return priceBodyTemplate(rowData[col.field][col.name]);
  };
  const lockTemplate = (lock) => {

    const icon = lock ? 'pi pi-lock' : 'pi pi-lock-open';

    return <Button type="button" icon={icon} onClick={() => setSetTitleAFrozen(!lock)} className="p-button-sm p-button-text" />;
  };

  const BodyTemplateForTitle = (titleA, titleB, titleC, titleD) => {

    if (titleA) {
      return (<span>{titleA}</span>);
    }
    if (titleB) {
      return (<span>{titleB}</span>);
    }
    if (titleC) {
      return (<span>{titleC}</span>);
    }
    return (<span>{titleD}</span>);
  }

  return (
    <>
      <div style={{ textAlign: "end", padding: "10px" }}>
        <button type="button" className="custom-button" title='Add' onClick={openModal} >
          + ADD
        </button>
      </div>
      <Toast ref={toast} />
      {/* ----------------------------------------------------------------------------------------  */}
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (<div className="card">


        <DataTable value={budgetList} stripedRows size="small" headerColumnGroup={headerGroup} scrollable scrollHeight="82vh" rowClassName={rowClass} showGridlines tableStyle={{ minWidth: '50rem', fontSize: '13px' }}>
          {/* <Column field="titleA" style={{ minWidth: '100px' }}  />
          <Column field="titleB" style={{ minWidth: '100px' }}  />
          <Column field="titleC" style={{ minWidth: '100px' }}  />
          <Column field="titleD" style={{ minWidth: '150px' }}  /> */}

          <Column style={{ minWidth: '100px' }} frozen body={(e) => BodyTemplateForTitle(e.titleA, e.titleB, e.titleC, e.titleD)} />
          <Column field="titleE" style={{ minWidth: '250px' }} frozen />
          {/* <Column field="titleE" style={{ minWidth: '300px' }}  /> */}
          <Column field="titleF" style={{ minWidth: '180px' }} frozen />
          <Column field="titleG" style={{ minWidth: '180px' }} frozen />
          <Column field="titleH" style={{ minWidth: '150px' }} frozen />


          {rowList.map((col, i) => (
            <Column field={col.name} body={(e) => lastYearSaleBodyTemplate(col, e)} style={{ minWidth: '120px', textAlign: 'center', padding: "7px" }} />

          ))}
        </DataTable>
      </div>)}

      <Dialog header="" visible={isModalOpen} maximizable style={{ width: '50vw' }} onHide={() => setIsModalOpen(false)}>

        <div className='card'>
          <form onSubmit={handleFileSubmit} >


            <div className="formmm">
              <div className="row">
                <Dropdown
                  value={selectedYear}
                  onChange={(e) => { console.log(e.value); setSelectedYear(e.value) }}
                  options={yearsList}
                  optionLabel="year"
                  editable
                  required
                  placeholder="Select a Year"
                  className="w-full dropdown-padding"
                  virtualScrollerOptions={{ itemSize: 28 }}
                />

                <Dropdown
                  value={selectedMonth}
                  onChange={(e) => { console.log(e.value); setSelectedMonth(e.value) }}
                  options={monthsList}
                  optionLabel="month"
                  editable
                  required
                  placeholder="Select a Month"
                  className="w-full dropdown-padding"
                  virtualScrollerOptions={{ itemSize: 28 }}
                />
              </div>
            </div>


            <div className="flex-col px-3 mt-4">
              <input type="file" className='uploadfile w-full' required onChange={handleFile} />

              <div  className="w-full flex mt-5" style={{justifyContent:'center'}}>
                {isFormSubmitLoadder ? (
                  <button type='button' className='customSave-button' >   <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" animationDuration=".5s" /></button>
                ) : (<Button type='submit' className='customSave-button' > SUBMIT </Button>)}
              </div>
            </div>
          </form>


          {typeError && (
            <div style={{ color: "red", display: "block", textAlign: 'center', fontSize: '2rem', fontWeight: 'bold' }}>
              {typeError}
            </div>
          )}


        </div>

      </Dialog>

      {isReplaceConfirmationModalOpen && (
        <div className="modal">
          <div className="small-modal-content">
            <div className="modal-headerx">
              <h5 className="modal-title">Confirmation</h5>
              <button className="modal-closex" onClick={(e) => setIsReplaceConfirmationModalOpen(false)}>
                &times;
              </button>
            </div>
            <div className="modal-bodyx">
              <p>{isRelplaceMessage}</p>
            </div>
            <div className="modal-footer-cancelx">
              <button className="cancel-buttonx" onClick={(e) => setIsReplaceConfirmationModalOpen(false)}>
                Cancel
              </button>
              {isFormSubmitLoadder ? (


                <button className='delete-buttonx' >   <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" animationDuration=".5s" /></button>
              ) : (<button className="delete-buttonx" onClick={handleFileSubmit}>
                SAVE
              </button>)}



            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Budget;
